import { isIE11 } from '@fluentui/react';
/**
 * Adding support for IE11 by polyfilling missing language features that are required
 * to use Create React App.
 *
 * Per npmjs.com/package/react-app-polyfill, this must referenced in first line in the
 * consuming app:
 *
 * ```js
 *   import '@msrceng/component/lib/InternetExplorer/polyfill';
 * ```
 */
const internetExplorer11Polyfill = (() => {
    if (isIE11()) {
        require('react-app-polyfill/ie11');
        require('react-app-polyfill/stable');
        require('core-js');
    }
})();
export { internetExplorer11Polyfill };
